import React, { useState, useEffect } from "react";
import Page from "@atlaskit/page";
import { useSelector, useDispatch } from "react-redux";
import CommentBox from "./template/CommentBox";
import { useParams } from "react-router-dom";
import { setEditorSaved } from "../../../../../redux/actions/integrationActions";
import ActionMenu from "../../../../../integrations/flow/edit/action/menu/ActionMenu";
import MidSectionExtensions from "../../../../../integrations/flow/edit/action/extension/MidSectionExtensions";
import MenuSectionExtensions from "../../../../../integrations/flow/edit/action/extension/MenuSectionExtensions";
import ConditionsPage from "../../../../../integrations/flow/edit/action/tabs/conditionsTab/ConditionsPage";
import IteratorInput from "../../../../../integrations/flow/edit/action/tabs/behavioursTab/IteratorInput";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import VariablesPage from "../../../../../integrations/flow/edit/action/tabs/variablesTab/VariablesPage";
import GetHelpExtensions from "../../../../../integrations/flow/edit/action/extension/GetHelpExtensions";
import ActionStatusToggle from "../../../../../integrations/flow/edit/action/ActionStatusToggle";

const IssueCommentActionPage = () => {
  const dispatch = useDispatch();
  const flow = useSelector((state) => state.integration.flow);
  const { sectionId } = useParams();
  const [currentAction, setCurrentAction] = useState(null);

  useEffect(() => {
    if (flow.actions) {
      const action = flow.actions.find((a) => a.id === sectionId);
      if (action) {
        setCurrentAction(action);
      }
    }
  }, [sectionId, flow]);

  const updateComment = () => {
    mergeCurrentActionToFlow();
    dispatch(setEditorSaved(false));
  };

  const mergeCurrentActionToFlow = () => {
    const action = flow.actions.find((a) => a.id === sectionId);
    const index = flow.actions.indexOf(action);
    flow.actions[index] = currentAction;
  };

  return (
    <Page>
      <Tabs>
        <TabList>
          <Tab>Request Configuration</Tab>
          <Tab>Conditions</Tab>
          <Tab>Variables</Tab>
          <Tab>Behaviour</Tab>
        </TabList>
        <TabPanel>
          {" "}
          <div className="ihub-action-page">
            <div className="ihub-webaction-header">
              <h4>Action: Issue Comment</h4>
              <div className="ihub-actionmenu-action">
                <GetHelpExtensions />
                <MenuSectionExtensions action={currentAction} />
                <ActionMenu action={currentAction} />
                <ActionStatusToggle action={currentAction} flow={flow} />
              </div>
            </div>
            <MidSectionExtensions />
            <p>Please enter the comment to add in the box below. </p>Comment<span className="ihub-required">*</span>
            <CommentBox action={currentAction} update={updateComment} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <ConditionsPage action={currentAction} flow={flow} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <VariablesPage action={currentAction} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <IteratorInput action={currentAction} />
          </div>
        </TabPanel>
      </Tabs>
    </Page>
  );
};
export default IssueCommentActionPage;
